

<div style="width:auto; height: auto;">
  <!-- <div class="winwheelicon" style="background-repeat: no-repeat;"></div> -->
  <canvas className="ta_c" id="canvas" width="500px" height="450px"></canvas>
</div>
